// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TerritoryAddToCheckbox {
  margin-right: 8px;
}
.TerritoryAddToCheckbox [class^=dist_Checkbox-wrapper] {
  gap: 0;
}`, "",{"version":3,"sources":["webpack://./src/components/TerritoryAddToCheckbox/index.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;AACF;AACE;EACE,MAAA;AACJ","sourcesContent":[".TerritoryAddToCheckbox {\n  margin-right: 8px;\n\n  [class^='dist_Checkbox-wrapper'] {\n    gap: 0;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
